<div class="contact-form-card simple-contact-form">
    <div class="simple-contact-form-heading">
        <h3>Appointment request</h3>
        <p>Send your contact details, property address, inspection type, and preferred timing.</p>
    </div>

    <form [formGroup]="contactForm" (ngSubmit)="submitForm()" novalidate>
        <!-- Contact Name -->
        <div class="form-group">
            <label for="name" class="control-label">Name</label>
            <input id="name" type="text" formControlName="name" class="form-control" autocomplete="name"
                placeholder="John Smith"
                aria-describedby="nameHint nameError"
                [attr.aria-invalid]="contactForm.controls.name.invalid && contactForm.controls.name.touched"
                [class.is-invalid]="contactForm.controls.name.invalid && contactForm.controls.name.touched">
            <small id="nameHint" class="simple-field-hint">Best name for GTX follow-up.</small>
            <div *ngIf="contactForm.controls.name.invalid && contactForm.controls.name.touched" id="nameError" class="text-danger">
                Name is required.
            </div>
        </div>

        <!-- Phone Number -->
        <div class="form-group">
            <label for="phoneNumber" class="control-label">Phone Number</label>
            <input id="phoneNumber" type="tel" formControlName="phoneNumber" class="form-control" autocomplete="tel"
                placeholder="(512) XXX-XXXX"
                aria-describedby="phoneHint contactMethodError"
                [attr.aria-invalid]="contactMethodErrorVisible"
                [class.is-invalid]="contactMethodErrorVisible">
            <small id="phoneHint" class="simple-field-hint">Call or text works.</small>
            <div *ngIf="contactMethodErrorVisible" id="contactMethodError" class="text-danger">
                Phone number or email is required.
            </div>
        </div>

        <!-- Email -->
        <div class="form-group">
            <label for="emailAddress" class="control-label">Email</label>
            <input id="emailAddress" type="email" formControlName="emailAddress" class="form-control"
                autocomplete="email" placeholder="johnsmith@example.com"
                aria-describedby="emailHint emailError contactMethodError"
                [attr.aria-invalid]="(contactForm.controls.emailAddress.invalid && contactForm.controls.emailAddress.touched) || contactMethodErrorVisible"
                [class.is-invalid]="(contactForm.controls.emailAddress.invalid && contactForm.controls.emailAddress.touched) || contactMethodErrorVisible">
            <small id="emailHint" class="simple-field-hint">Where GTX can reply.</small>
            <div *ngIf="contactForm.controls.emailAddress.invalid && contactForm.controls.emailAddress.touched"
                id="emailError" class="text-danger">
                Enter a valid email address.
            </div>
        </div>

        <!-- Message -->
        <div class="form-group">
            <label for="message" class="control-label">Message</label>
            <textarea id="message" formControlName="message" class="form-control"
                placeholder="Property address, inspection type, preferred timing, and questions"
                maxlength="500"
                aria-describedby="messageHint messageError"
                [attr.aria-invalid]="contactForm.controls.message.invalid && contactForm.controls.message.touched"
                [class.is-invalid]="contactForm.controls.message.invalid && contactForm.controls.message.touched"></textarea>
            <small id="messageHint" class="simple-field-hint">Address, timing, inspection type, and any questions.</small>
            <div *ngIf="contactForm.controls.message.invalid && contactForm.controls.message.touched"
                id="messageError" class="text-danger">
                Message is required and cannot exceed 500 characters.
            </div>
        </div>

        <div class="form-group simple-submit-row">
            <button type="submit" class="ng-button ng-button-primary" [disabled]="loading || contactForm.invalid">
                {{ loading ? 'Sending request...' : 'Submit request' }}
            </button>
            <p class="simple-submit-note">
                GTX uses this information to respond and coordinate scheduling.
                <a routerLink="/privacy-policy">Privacy Policy</a>
            </p>
        </div>

        <!-- Success Message -->
        <div *ngIf="successMessage" class="alert success-alert" aria-live="polite">
            {{ successMessage }}
        </div>

        <!-- Error Message -->
        <div *ngIf="errorMessage" class="alert error-alert" aria-live="assertive">
            {{ errorMessage }}
        </div>
    </form>
</div>
